import { render } from "./EntryCalculatorsMenu.vue?vue&type=template&id=bf3affb4&scoped=true"
import script from "./EntryCalculatorsMenu.vue?vue&type=script&lang=js"
export * from "./EntryCalculatorsMenu.vue?vue&type=script&lang=js"

import "./EntryCalculatorsMenu.vue?vue&type=style&index=0&id=bf3affb4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf3affb4"]])

export default __exports__